<div class="thumbnail">
  <div draggable="true"  (dragend)="notifyDragEvent('end',$event)" class="thumbnail-image" (dragstart)="notifyDragEvent('start',$event)" >
    <!-- <img   mat-card-image [src]="apiThumbnailPath$ | secureImgLink | async">  -->
    <img   mat-card-image [src]="apiThumbnailPath$ | async"> 
    <div class="thumbnail-description">
      {{thumbnailText}}
    </div>
  </div>
</div>